import Vue from 'vue'
import Router from 'vue-router'
import Home from "../components/Home";//导航
import Content from "../components/Content";//首页
import Enterprise from "../components/Enterprise";//企业资质

import Buy from "../components/Buy";//产品介绍
import BuyGo from "../components/Buy/BuyGo";//产品展示
import Resiliometer from "../components/Buy/Resiliometer";//回弹仪
import VR from "../components/Buy/VR";//智慧展厅
import AR from "../components/Buy/AR";//AR服务
import MR from "../components/Buy/MR";//MR
import inspection from "../components/Buy/inspection";// ai移动巡检
import Experience from "../components/Buy/Experience";//体验馆集装箱
import Quality from "../components/Buy/Quality";//质量样板展示区
import Interaction from "../components/Buy/Interaction";//互动台
import ThreeDimensional from "../components/Buy/ThreeDimensional";// 项目案例
import omsSystem from "../components/coreBusiness/omsSystem";
import propertyManagement from "../components/coreBusiness/propertyManagement";
import AboutUs from "../components/AboutUs";//关于我们
import CompanyProfile from "../components/AboutUs/CompanyProfile";//公司简介
import SolarRobot from "../components/Buy/SolarRobot";//光伏清扫机器人

import News from "../components/News";    //新闻资讯
import NewsProfile from "../components/News/NewsProfile";//新闻简介
// import NewsOne from "../components/News/NewsOne";
// import NewsTwo from "../components/News/NewsTwo";
// import NewsThree from "../components/News/NewsThree";
// import NewsFour from "../components/News/NewsFour";
// import NewsFive from "../components/News/NewsFive";
// import NewsSix from "../components/News/NewsSix";
// import NewsSeven from "../components/News/NewsSeven";
// import NewsEight from "../components/News/NewsEight";
// import NewsNine from "../components/News/NewsNine";
// import NewsTen from "../components/News/NewsTen";
// import NewsEleven from "../components/News/NewsEleven";
// import NewsTwelve from "../components/News/NewsTwelve";
// import NewsThirteen from "../components/News/NewsThirteen";
import NewsDetails from "../components/News/NewsDetails";
import smartsite from "../components/solutions/smartsite";
import artificialintelligence from "../components/solutions/artificialintelligence";
import actualmeasurement from "../components/solutions/actualmeasurement";
import safetyhelmet from "../components/solutions/safetyhelmet";
import exhibitionHall from "../components/solutions/exhibitionHall";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Home,
            children: [
                /*首页*/
                {
                    path: '/',
                    redirect: '/home/content/contentWisdomSite',
                    meta: {
                        title: '河南南秀数智科技有限公司'
                    }
                },
                {
                    path: '/home/content',
                    name: 'Content',
                    component: Content,
                    meta: {
                        title: '河南南秀数智科技有限公司'
                    },
                    children: [
                        /*智慧工地*/
                        {
                            path: '/home/content/contentWisdomSite',
                            name: 'contentWisdomSite',
                            component: () => import('../components/Content/WisdomSite'),
                            meta: {
                                title: '河南南秀数智科技有限公司'
                            }
                        },
                        /*智慧投影*/
                        {
                            path: '/home/content/contentWisdomProjection',
                            name: 'contentWisdomProjection',
                            component: () => import('../components/Content/WisdomProjection')
                        },
                        /*智慧滑轨屏*/
                        {
                            path: '/home/content/contentSlideScreen',
                            name: 'contentSlideScreen',
                            component: () => import('../components/Content/SlideScreen')
                        },
                        /*智能测量设备*/
                        {
                            path: '/home/content/contentResiliometer',
                            name: 'contentResiliometer',
                            component: () => import('../components/Content/Resiliometer')
                        },
                        /*互动点子沙盘*/
                        {
                            path: '/home/content/contentInteraction',
                            name: 'contentInteraction',
                            component: () => import('../components/Content/Interaction')
                        },
                        /*VR安全体验区*/
                        {
                            path: '/home/content/contentVR',
                            name: 'contentVR',
                            component: () => import('../components/Content/VR')
                        },
                        /*工法质量样板*/
                        {
                            path: '/home/content/contentQuality',
                            name: 'contentQuality',
                            component: () => import('../components/Content/Quality')
                        },
                        /*安全教育*/
                        {
                            path: '/home/content/contentSafetyEducation',
                            name: 'contentSafetyEducation',
                            component: () => import('../components/Content/SafetyEducation')
                        }
                    ]
                },
                /*企业资质*/
                {
                    path: '/home/enterPrise',
                    name: 'Enterprise',
                    component: Enterprise,
                    meta: {
                        title: '企业资质'
                    }
                },
                /*产品介绍*/
                {
                    path: '/home/Buy',
                    component: Buy,
                    redirect: '/home/Buy/VR',
                    meta: {
                        title: '企业产品'
                    },
                    children: [
                        /*VR*/
                        {
                            path: '/home/Buy/VR',
                            name: 'VR',
                            component: VR,
                            meta: {
                                title: '智慧展厅'
                            }
                        },
                        /*AR*/
                        {
                            path: '/home/Buy/AR',
                            name: 'AR',
                            component: AR,
                            meta: {
                                title: '智慧展厅'
                            }
                        },
                        /*MR*/
                        {
                            path: '/home/Buy/MR',
                            name: 'MR',
                            component: MR,
                            meta: {
                                title: '智慧展厅'
                            }
                        },
                        /*智慧工地*/
                        {
                            path: "/home/Buy/WisdomSite",
                            name: 'BuyWisdomSite',
                            component: () => import('../components/Buy/WisdomSite')
                        },
                        /*安全教育*/
                        {
                            path: '/home/Buy/SafetyEducation',
                            name: 'SafetyEducation',
                            component: () => import('../components/Buy/SafetyEducation')
                        },
                        /*智能测量设备*/
                        {
                            path: '/home/Buy/Resiliometer',
                            name: 'Resiliometer',
                            component: Resiliometer,
                            meta: {
                                title: '实测实量'
                            },
                        },
                        /*安全体验馆*/
                        {
                            path: '/home/Buy/Experience',
                            name: 'Experience',
                            component: Experience,
                            meta: {
                                title: '安全体验馆'
                            }
                        },
                        /*质量样板展示区*/
                        {
                            path: '/home/Buy/Quality',
                            name: 'Quality',
                            component: Quality,
                            meta: {
                                title: '安全体验区'
                            }
                        },
                        /*互动台*/
                        {
                            path: '/home/Buy/Interaction',
                            name: 'Interaction',
                            component: Interaction,
                            meta: {
                                title: '物体识别互动台'
                            }
                        },
                        /*展厅项目案例*/
                        {
                            path: '/home/Buy/ThreeDimensional',
                            name: 'ThreeDimensional',
                            component: ThreeDimensional,
                            meta: {
                                title: '展厅项目案例'
                            }
                        },
                        /*AI移动巡检*/
                        {
                            path: '/home/Buy/inspection',
                            name: 'inspection',
                            component: inspection,
                            meta: {
                                title: 'AI智能巡检'
                            }
                        },
                        /*光伏清扫机器人*/
                        {
                            path: '/home/Buy/SolarRobot',
                            name: 'SolarRobot',
                            component: SolarRobot,
                            meta: {
                                title: '光伏清扫机器人'
                            }
                        },
                    ]
                },
                {
                    path: '/home/buyGo',
                    name: 'BuyGo',
                    component: BuyGo,
                    meta: {
                        title: '购买页面'
                    }
                },
                /*关于我们*/
                {
                    path: '/home/AboutUs',
                    component: AboutUs,
                    meta: {
                        title: '关于我们'
                    },
                    children: [
                        /*公司简介*/
                        {
                            path: '/',
                            name: 'CompanyProfile',
                            component: CompanyProfile,
                            meta: {
                                title: '公司概况'
                            },
                        },
                    ]
                },
                /*新闻资讯*/
                {
                    path: '/home/News',
                    component: News,
                    meta: {
                        title: '新闻资讯'
                    },
                    children: [
                        {
                            path: '/',
                            name: 'NewsProfile',
                            component: NewsProfile,
                            meta: {
                                title: '企业新闻'
                            },
                        },
                        {
                            path: '/home/News/NewsDetails',
                            name: 'NewsDetails',
                            component: NewsDetails,
                            meta: {
                                title: ''
                            },
                        }

                    ]
                },
                // 核心业务
                {
                    path: '/home/propertyManagement',
                    component: propertyManagement,
                    meta: {
                        title: '物管平台'
                    },

                },
                {
                    path: '/home/omsSystem',
                    component: omsSystem,
                    meta: {
                        title: 'OMS订单管理系统'
                    },

                },
                {
                    path: '/home/smartsite',
                    component: smartsite,
                    meta: {
                        title: '智慧工地解决方案'
                    },
                },
                {
                    path: '/home/exhibitionHall',
                    component: exhibitionHall,
                    meta: {
                        title: '智慧展厅一体化解决方案'
                    },
                },
                {
                    path: '/home/artificialintelligence',
                    component: artificialintelligence,
                    meta: {
                        title: '人工智能算法解决方案'
                    },
                },
                {
                    path: '/home/actualmeasurement',
                    component: actualmeasurement,
                    meta: {
                        title: '实测实量解决方案'
                    },
                },
                {
                    path: '/home/safetyhelmet',
                    component: safetyhelmet,
                    meta: {
                        title: '移动巡检安全帽解决方案'
                    },
                },
                /*光伏清扫机器人*/
                {
                    path: '/home/solutions/PhotovoltaicCleaningRobot',
                    name: 'PhotovoltaicCleaningRobot',
                    component: () => import('../components/solutions/PhotovoltaicCleaningRobot'),
                    meta: {
                        title: '光伏清扫机器人'
                    }
                },

                /*联系我们*/
                {
                    path: '/home/ContactUs',
                    name: 'ContactUs',
                    component: () => import('../components/ContactUs')
                },
                /*智慧工地*/
                {
                    path: '/home/WisdomSite',
                    name: 'WisdomSite',
                    component: () => import('../components/WisdomSite'),
                    meta: {
                        title: "解决方案"
                    }
                }
            ]
        },
    ]
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
});

// 跳转过后能够直接到顶点
// router.afterEach((to, from, next) => {
//     document.body.scrollTop = 0;
//     document.documentElement.scrollTop = 0;
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js